import React from 'react';
import PropTypes from 'prop-types';
import {
  CardHeader,
  CardContent,
  Typography,
} from '@mui/material';

import User from '../../../User';
import EventUpload from '../../../EventUpload';
import { getUser } from '../../../../utils/userHelper';
import { formatDateString } from '../../../../utils/dateHelper';

export class HistoryItemComponent extends React.Component {
  render() {
    const {
      item,
      classes,
      children,
      event,
    } = this.props;
    const cardClasses = [classes.card];

    return (
      <div className={classes.container}>
        <div className={cardClasses.join(' ')}>
          <CardHeader
            classes={{
              root: classes.cardHeader,
              avatar: classes.cardAvatar,
              content: classes.cardHeaderContent,
            }}
            avatar={(
              <User
                user={getUser({
                  email: item.createdByEmail,
                  userFullName: item.createdByName,
                })}
                secondary={formatDateString(item.createdDate)}
                userAction={(
                  <span>
                    &nbsp;uploaded an <strong>attachment</strong>
                    {
                      !!event
                        && (
                          <span>
                            &nbsp;for <strong>{event.name}</strong> <Typography variant="caption" className={classes.eventIdField}>(#{event.id})</Typography>
                          </span>
                        )
                    }
                  </span>
                )}
              />
            )}
          />
          <CardContent className={classes.comment} classes={{ root: classes.commentLastChild }}>
            <div>
              <EventUpload eventUpload={item} preview />
            </div>
          </CardContent>
        </div>
        {
          children
        }
      </div>
    );
  }
}

HistoryItemComponent.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  children: PropTypes.any,
  event: PropTypes.object,
};

HistoryItemComponent.defaultProps = {
  classes: {},
  item: {},
  children: null,
  event: null,
};

export default HistoryItemComponent;
